'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'styles/WidgetHeading.scss';

const propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    subText: PropTypes.string,
};

class WidgetHeading extends React.Component {

    render() {

        var classes = classNames('widget-heading', this.props.className);
        
        return (
            <div id={this.props.id ? this.props.id : ""} className={classes}>
                <div className="wh-label">{this.props.label}</div>
                {this.props.subText ? <div className="wh-subText">{this.props.subText}</div> : null}
            </div>
        );
    }
}

WidgetHeading.propTypes = propTypes;

export default WidgetHeading; 